import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getQuotationDetailByIdSlice = createSlice({
    name: "getQuotationDetailById",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getQuotationDetailByIdSlice_actions = getQuotationDetailByIdSlice.actions;
export var fetchData = _getQuotationDetailByIdSlice_actions.fetchData, fetchDataSuccess = _getQuotationDetailByIdSlice_actions.fetchDataSuccess, fetchDataFailure = _getQuotationDetailByIdSlice_actions.fetchDataFailure, resetState = _getQuotationDetailByIdSlice_actions.resetState;
export default getQuotationDetailByIdSlice.reducer;
